import { render, staticRenderFns } from "./priceForm.vue?vue&type=template&id=6efdb9fc&scoped=true"
import script from "./priceForm.vue?vue&type=script&lang=js"
export * from "./priceForm.vue?vue&type=script&lang=js"
import style0 from "./priceForm.vue?vue&type=style&index=0&id=6efdb9fc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6efdb9fc",
  null
  
)

export default component.exports